import { useEffect, useState } from 'react';
import { IconArrowLeftSlide, IconArrowRightSlide, IconGooglePlay, IconappStore } from '@/components/icons/MainIcons';
import { getApiBaseUrl, getStorageUrl } from '@/utils/utils';
import { SliderData } from '@/types/global.types';
import { useLocalization } from '@/context/useLocalization';

const FooterPanel = () => {
    const [dataPanel, setDataPanel] = useState<SliderData[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const { getLocalizedContent } = useLocalization();

    useEffect(() => {
        fetch(`${getApiBaseUrl()}/slider_banner`)
            .then((response) => response.json())
            .then((data) => {
                if (Array.isArray(data.data)) {
                    setDataPanel(data.data);
                } else {
                    console.error('Error: data.data is not an array', data);
                    setDataPanel([]);
                }
            })
            .catch((error) => console.error('Error fetching Footer data:', error));
    }, []);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % dataPanel.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + dataPanel.length) % dataPanel.length);
    };

    return (
        <div id="footer">
            <div className="mainContainer w-full select-none">
                <div className="flex items-center justify-center relative w-full">
                    {dataPanel?.length > 0 && (
                        <div className="md:mt-[88px] mt-[84px] flex items-center justify-center relative w-full">
                            {/* Prev */}
                            {dataPanel?.length > 1 && (
                                <button
                                    onClick={handlePrev}
                                    className="arrowSlideFooter absolute lg:-left-[27px] md:-left-[23px] left-[0px]"
                                >
                                    <IconArrowLeftSlide className="iconArrow" />
                                </button>
                            )}

                            <div className="footerImg w-full grid lg:grid-cols-2 grid-cols-1 overflow-hidden gap-3">
                                <div className="py-[55px] flex flex-col gap-y-12  justify-between xl:px-[30px] lg:px-[26px] md:px-[20px] sm:px-[50px] px-[18.5px] relative w-full text-center lg:text-start">
                                    <div className="">
                                        <h3
                                            className="leading-[1.1] headFooter w-full text-Grey20"
                                            dangerouslySetInnerHTML={{
                                                __html: getLocalizedContent(dataPanel[currentIndex].title),
                                            }}
                                        />

                                        <p className="md:text-[24px] text-[20px] font-medium text-Grey20 md:mt-[20px] mt-[16px] ">
                                            {getLocalizedContent(dataPanel[currentIndex].description)}
                                        </p>
                                    </div>

                                    <div className="flex xl:gap-4 lg:gap-[14px] md:gap-4 gap-[13px] lg:mx-0 mx-auto">
                                        <button
                                            className="mainRounded dark:bg-main bg-Grey20 md:px-[30px] sm:px-[25px] px-[16px] md:py-[12px] sm:py-[10px] py-[5px] head-border cursor-pointer hover:shadow-2xl transition-shadow duration-200"
                                            onClick={() => {
                                                const appStoreLink =
                                                    dataPanel[currentIndex]?.social_links?.find(
                                                        (link) => link.platform === 'google_play',
                                                    )?.link || '#';

                                                if (appStoreLink !== '#') {
                                                    window.open(appStoreLink, '_blank');
                                                } else {
                                                    console.log('رابط App Store غير متوفر');
                                                }
                                            }}
                                        >
                                            <IconGooglePlay className="dark:text-white text-main lg:w-[150px] md:w-[145px] sm:w-[115px] w-[100px]" />
                                        </button>
                                        <button
                                            className="mainRounded dark:bg-main bg-Grey20 xl:px-[50px] lg:px-[43px] md:px-[39px] sm:px-[28px] px-[23px] md:py-[12px] sm:py-[10px] py-[5px] head-border cursor-pointer hover:shadow-2xl transition-shadow duration-200"
                                            onClick={() => {
                                                const appStoreLink =
                                                    dataPanel[currentIndex]?.social_links?.find(
                                                        (link) => link.platform === 'app_store',
                                                    )?.link || '#';

                                                if (appStoreLink !== '#') {
                                                    window.open(appStoreLink, '_blank');
                                                } else {
                                                    console.log('رابط App Store غير متوفر');
                                                }
                                            }}
                                        >
                                            <IconappStore className="dark:text-white text-main lg:w-[150px] md:w-[145px] sm:w-[115px] w-[100px]" />
                                        </button>
                                    </div>
                                </div>

                                <div className="lg:flex hidden items-end justify-end px-2 h-full pt-[55px]">
                                    <img
                                        loading="lazy"
                                        src={getStorageUrl(dataPanel[currentIndex].image)}
                                        alt={getLocalizedContent(dataPanel[currentIndex].title)}
                                        className="h-full object-cover md:h-[425px] xl:w-[570px] w-[440px]"
                                    />
                                </div>
                            </div>

                            <div className="embla__pagination flex justify-center gap-2 absolute md:bottom-[-40px] bottom-[-25px]">
                                {dataPanel.map((_, index) => (
                                    <button
                                        key={index}
                                        className={`embla__dot rounded-full transition-colors duration-300 ${
                                            currentIndex === index ? 'bg-main w-8 h-3 ' : 'bg-[#C6C6C6] w-3 h-3'
                                        }`}
                                        onClick={() => setCurrentIndex(index)}
                                    ></button>
                                ))}
                            </div>

                            {/* Next */}
                            {dataPanel?.length > 1 && (
                                <button
                                    onClick={handleNext}
                                    className="arrowSlideFooter absolute lg:-right-[27px] md:-right-[23px] right-[0px]"
                                >
                                    <IconArrowRightSlide className="iconArrow" />
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FooterPanel;
